<template>
    <v-card class="custom-dailog files-media-popup">
        <v-card-title>
            {{ communityCommonConstant.filesAndMedia.TITLE }}
            <small class="files-media-popup__sub"> {{ communityName }}</small>
            <i class="fas fa-times" @click="closeFilesDialog()" data-qe-id="files-and-media_list_close_btn"></i>
        </v-card-title>

        <v-card-text class="inner-scrollbar">
            <span v-if="filesAndMediaError" class="error-msg" data-qe-id="files-and-media_upload_duplicate_name">
                {{ communityCommonConstant.filesAndMedia.DUPLICATE_NAME }}
            </span>
            <v-layout row wrap>
                <v-flex xs8 class="files-media-popup__breadcrumb">
                    <span v-if="canNavigateUp" data-qe-id="files-and-media_home_btn" @click="home()" class="pointer">
                        <i class="fas fa-home"></i>
                        <i class="fas fa-angle-left"></i>
                    </span>
                    <strong
                        v-if="currentRoot && currentRoot.parentId"
                        @click="navigateUp()"
                        data-qe-id="files-and-media_navigate-up_btn"
                        class="pointer"
                    >
                        <i class="fas fa-folder"></i>
                        {{ parentName }}
                        <i class="fas fa-angle-left"></i>
                    </strong>
                    <strong v-if="currentRoot"><i class="fas fa-folder"></i>{{ currentRoot.name }}</strong>
                </v-flex>
                <v-flex xs4 class="files-media-popup__icons" v-if="isVisible">
                    <div v-if="isReordered">
                        <v-btn
                            class="primary_btn transparent small"
                            data-qe-id="files-and-media_cancel_ordering_btn"
                            @click="cancelOrder"
                        >
                            {{ appCommonConstants.CANCEL }}
                        </v-btn>
                        <v-btn
                            class="primary_btn small"
                            data-qe-id="files-and-media_save_ordering_btn"
                            @click="saveOrder"
                        >
                            {{ appCommonConstants.SAVE }}
                        </v-btn>
                    </div>
                    <div v-if="!isReordered && isAddFolder && canViewEdit">
                        <span data-qe-id="files-and-media_share_link_copied_msg" class="share-link-copied-message" v-if="shareLinkCopiedMessage.length">{{
                            shareLinkCopiedMessage
                        }}</span>
                        <v-icon
                            class="fas fa-file-medical"
                            v-if="currentRoot !== null"
                            data-qe-id="files-and-media_add-a-file_btn"
                            :title="communityCommonConstant.filesAndMedia.ADD_FILE_TOOLTIP"
                            @click="displayFilesLayout()"
                        >
                        </v-icon>
                        <v-icon
                            class="fas fa-folder-plus"
                            data-qe-id="files-and-media_add-a-folder_btn"
                            @click="folderActivity()"
                            :title="communityCommonConstant.filesAndMedia.ADD_FOLDER"
                        >
                        </v-icon>
                    </div>
                </v-flex>
            </v-layout>
            <v-flex xs12 v-if="isShowFilesContainer && currentRoot !== null">
                <file-drag-drop-area
                    @closeDialog="closeFilesDragDropArea"
                    :existingFileNames="filesAndMediaData.map((item) => item.name)"
                    :parentid="currentRoot === null ? null : currentRoot.id"
                    :parentDirectory="this.currentRoot === null ? null : currentRoot.fileUrl"
                    :fileTypesSupported="communityCommonConstant.filesAndMedia.FILETYPES_SUPPORTED"
                ></file-drag-drop-area>
            </v-flex>
            <v-flex xs12>
                <v-layout row wrap class="headding hidden-xs">
                    <v-flex xs1>
                        <a
                            @click="
                                orderMediaBy(communityCommonConstant.filesAndMedia.tableColumns.TYPE.value, typeAsc)
                            "
                            data-qe-id="files-and-media_order-by_type"
                        >
                            {{ communityCommonConstant.filesAndMedia.tableColumns.TYPE.key }}
                        </a>
                    </v-flex>
                    <v-flex xs3 pl-2>
                        <a
                            @click="
                                orderMediaBy(communityCommonConstant.filesAndMedia.tableColumns.NAME.value, nameAsc)
                            "
                            data-qe-id="files-and-media_order-by_name"
                        >
                            {{ communityCommonConstant.filesAndMedia.tableColumns.NAME.key }}
                            <span v-if="nameAsc" class="fas fa-sort-up"></span>
                            <span v-else class="fas fa-sort-down"></span>
                        </a>
                    </v-flex>
                    <v-flex xs3 pl-2>
                        <a
                            @click="
                                orderMediaBy(
                                    communityCommonConstant.filesAndMedia.tableColumns.MODIFIED_BY.value,
                                    modifiedByAsc,
                                )
                            "
                            data-qe-id="files-and-media_order-by_modified-by"
                        >
                            {{ communityCommonConstant.filesAndMedia.tableColumns.MODIFIED_BY.key }}
                            <span v-if="modifiedByAsc" class="fas fa-sort-up"></span>
                            <span v-else class="fas fa-sort-down"></span>
                        </a>
                    </v-flex>
                    <v-flex xs4>
                        <a
                            @click="
                                orderMediaBy(
                                    communityCommonConstant.filesAndMedia.tableColumns.LAST_MODIFIED.value,
                                    dateAsc,
                                )
                            "
                            data-qe-id="files-and-media_order-by_last-modified"
                        >
                            {{ communityCommonConstant.filesAndMedia.tableColumns.LAST_MODIFIED.key }}
                            <span v-if="dateAsc" class="fas fa-sort-up"></span>
                            <span v-else class="fas fa-sort-down"></span>
                        </a>
                    </v-flex>
                    <v-flex xs3></v-flex>
                </v-layout>
                <v-flex class="scroll-div relative-position">
                    <Status-overlay v-if="filesAndMediaData" :action="filesLoadingAction"></Status-overlay>
                    <draggable
                        :list="filesAndMediaData"
                        :options="{
                            animation: 200,
                            disabled: !canReorder || isRowEditingOrCreating,
                            onSort: changeOrder(),
                        }"
                        :move="onListItemMove"
                    >
                        <v-layout
                            row
                            wrap
                            v-for="(element, i) in filesAndMediaData"
                            :key="i"
                            :data-qe-id="`files-and-media_drag_items_${i}`"
                            v-bind:class="[!canReorder || isRowEditingOrCreating ? 'dragDiv' : 'dragDiv cursor-move']"
                        >
                            <v-flex xs3 sm1 class="typeBlock" v-if="!element.isDeleteRow || !element.isEditRow">
                                <span :data-qe-id="`files-and-media_item_${i}_file_size`" v-if="!element.isNewRow && !element.isDeleteRow">
                                    {{ getFileSize(element.fileSize) }}
                                </span>
                                <v-icon
                                    large
                                    v-if="
                                        !element.isNewRow &&
                                            !element.isEditRow &&
                                            !element.isDeleteRow &&
                                            element.fileSubType === communityCommonConstant.filesAndMedia.FOLDER
                                    "
                                    @click="navigateToFolder(element)"
                                    :data-qe-id="`files-and-media_item_${i}_icon_btn`"
                                    :class="iconClassNames(element.fileSubType)"
                                ></v-icon>
                                <v-icon
                                    large
                                    v-if="
                                        !element.isNewRow &&
                                            !element.isEditRow &&
                                            !element.isDeleteRow &&
                                            element.fileSubType !== communityCommonConstant.filesAndMedia.FOLDER
                                    "
                                    :class="iconClassNames(element.fileExt)"
                                >
                                </v-icon>
                                <div v-if="element.isNewRow || element.isEditRow">
                                    <v-icon
                                        large
                                        :class="
                                            element.fileSubType
                                                ? iconClassNames(element.fileSubType)
                                                : iconClassNames(element.fileExt)
                                        "
                                    ></v-icon>
                                </div>
                                <span v-if="!element.isNewRow && !element.isDeleteRow && element.isFolder">
                                    {{ getFileCount(element.id) }}</span
                                >
                            </v-flex>
                            <v-flex
                                xs9
                                sm3
                                pr-2
                                class="nameBlock"
                                :data-qe-id="`files-and-media_item_${i}_file_count`"
                                v-if="!element.isEditRow && !element.isNewRow && !element.isDeleteRow"
                            >
                                <strong
                                    @click="
                                        element.fileSubType === communityCommonConstant.filesAndMedia.FOLDER
                                            ? navigateToFolder(element)
                                            : null
                                    "
                                    :data-qe-id="`files-and-media_item_${i}_name_link`"
                                    :class="{
                                        pointer: element.fileSubType === communityCommonConstant.filesAndMedia.FOLDER,
                                    }"
                                >
                                    {{ element.name }}
                                </strong>
                            </v-flex>
                            <v-flex xs12 sm11 v-if="element.isEditRow">
                                <v-layout row wrap>
                                    <v-flex xs12 sm8 class="inputBlock">
                                        <input
                                            type="text"
                                            v-model="isEditName"
                                            maxlength="30"
                                            :data-qe-id="`files-and-media_item_${i}_name_input_field`"
                                            v-on:keypress="isValidFolderName($event, isEditName)"
                                            v-on:keyup="
                                                duplicateName(
                                                    isEditName,
                                                    appCommonConstants.UPDATE,
                                                    element.fileSubType ===
                                                        communityCommonConstant.filesAndMedia.FOLDER,
                                                )
                                            "
                                        />
                                        <span v-if="isEditError"> {{ isErrorMessage }} </span>
                                    </v-flex>
                                    <v-flex xs12 sm4 text-xs-right class="btns_div">
                                        <v-btn
                                            class="primary_btn transparent small"
                                            :disabled="updateInProgress"
                                            :data-qe-id="`files-and-media_item_${i}_cancel_edit_btn`"
                                            @click="cancelDetails(element)"
                                        >
                                            {{ appCommonConstants.CANCEL }}
                                        </v-btn>
                                        <v-btn
                                            class="primary_btn small"
                                            :loading="updateInProgress"
                                            :data-qe-id="`files-and-media_item_${i}_save_edit_btn`"
                                            @click="updateDetails(element)"
                                            :disabled="isEditError"
                                            >{{ appCommonConstants.UPDATE }}</v-btn
                                        >
                                        <v-btn
                                            class="primary_btn transparent small pa-1"
                                            :data-qe-id="`files-and-media_item_${i}_delete_btn`"
                                            @click="deleteItem(element)"
                                        >
                                            <i class="fas fa-trash-alt "></i>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 v-if="element.isDeleteRow" class="delete_box">
                                <v-layout row wrap>
                                    <v-flex :data-qe-id="`files-and-media_item_${i}_delete_msg`" xs8 class="delete_box__title">
                                        {{ communityCommonConstant.filesAndMedia.DELETE_CONFIRMATION }}
                                    </v-flex>
                                    <v-flex xs4 text-xs-right class="delete_box__btns">
                                        <v-btn
                                            class="primary_btn  small outline"
                                            :disabled="deleteInProgress"
                                            data-qe-id="files-and-media_confirm_no_btn"
                                            @click="deleteCancel(element)"
                                        >
                                            {{ appCommonConstants.NO }}
                                        </v-btn>
                                        <v-btn
                                            :loading="deleteInProgress"
                                            class="primary_btn small outline"
                                            data-qe-id="files-and-media_confirm_yes_btn"
                                            @click="deleteDetails(element)"
                                        >
                                            {{ appCommonConstants.YES }}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm11 v-if="element.isNewRow">
                                <v-layout row wrap>
                                    <v-flex xs12 sm8 class="inputBlock">
                                        <input
                                            type="text"
                                            @focus="$event.target.select()"
                                            ref="newFolderField"
                                            autofocus
                                            v-model="element.name"
                                            data-qe-id="files-and-media_new-folder_input"
                                            maxlength="30"
                                            v-on:keypress="isValidFolderName($event, element.name)"
                                            v-on:keyup="
                                                duplicateName(
                                                    element.name,
                                                    appCommonConstants.SAVE,
                                                    element.fileSubType ===
                                                        communityCommonConstant.filesAndMedia.FOLDER,
                                                )
                                            "
                                        />
                                        <span :data-qe-id="`files-and-media_edit_folder_error_msg`" v-if="isSaveError"> {{ isErrorMessage }} </span>
                                    </v-flex>
                                    <v-flex xs12 sm4 text-xs-right>
                                        <v-btn
                                            class="primary_btn transparent small"
                                            :disabled="saveInProgress"
                                            data-qe-id="files-and-media_cancel_new_row_btn"
                                            @click="cancelEmptyRow(element.index)"
                                        >
                                            {{ appCommonConstants.CANCEL }}
                                        </v-btn>
                                        <v-btn
                                            :disabled="element.name.length === 0 || filesAndMediaError"
                                            :loading="saveInProgress"
                                            class="primary_btn small"
                                            data-qe-id="files-and-media_save_new_row_btn"
                                            @click="saveFolder(element)"
                                            >{{ appCommonConstants.SAVE }}</v-btn
                                        >
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex
                                xs12
                                sm3
                                pr-2
                                class="last-modified-by"
                                v-if="!element.isNewRow && !element.isEditRow && !element.isDeleteRow"
                            >
                                <v-list-tile>
                                    <v-list-tile-avatar>
                                        <img
                                            :data-qe-id="`files-and-media_modify_profile_img`"
                                            :src="element.profileImageUrl"
                                            :onerror="imageErrorFallback(element.fallbackProfileImageUrl)"
                                        />
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        {{ element.updatedUser }}
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-flex>
                            <v-flex
                                xs4
                                sm2
                                v-if="!element.isNewRow && !element.isEditRow && !element.isDeleteRow"
                                class="nameBlock"
                            >
                                <strong :data-qe-id="`files-and-media_modify_date`"> {{ getShortDate(element.lastModifiedDate) }} </strong>
                            </v-flex>
                            <v-flex
                                xs8
                                sm3
                                text-xs-right
                                v-if="!element.isNewRow && !element.isEditRow && !element.isDeleteRow"
                                class="actionsBlock"
                            >
                                <v-flex>
                                    <v-icon
                                        v-if="showDownloadIcon(element)"
                                        class="fas fa-download"
                                        loading="true"
                                        :data-qe-id="`files-and-media_item_${i}_download_link`"
                                        @click="downloadFolders(element)"
                                        :title="communityCommonConstant.filesAndMedia.DOWNLOAD"
                                    ></v-icon>
                                    <v-progress-circular
                                        class="download-progress-circle"
                                        v-if="element.downloadInProgress"
                                        indeterminate
                                        size="15"
                                        :width="2"
                                    ></v-progress-circular>
                                    <v-icon
                                        class="fas fa-link"
                                        v-if="!element.isFolder"
                                        :data-qe-id="`files-and-media_item_${i}_copy-file_link`"
                                        :title="communityCommonConstant.filesAndMedia.COPYLINK_TOOLTIP"
                                        @click="copyFileLink(`dv_share_link_${i}`)"
                                    ></v-icon>
                                    <v-icon
                                        class="far fa-paper-plane"
                                        v-if="!element.isFolder"
                                        :data-qe-id="`files-and-media_item_${i}_share_link`"
                                        :title="communityCommonConstant.filesAndMedia.SHARELINK_TOOLTIP"
                                        @click="copyFileLink(`dv_share_link_${i}`)"
                                    ></v-icon>
                                    <v-icon
                                        v-if="element.canEdit"
                                        @click="editGridRow(element)"
                                        :data-qe-id="`files-and-media_item_${i}_edit_btn`"
                                        class="fas fa-pencil-alt"
                                        :title="communityCommonConstant.filesAndMedia.EDIT"
                                    ></v-icon>
                                    <v-flex>
                                        <div
                                            v-if="!element.isFolder"
                                            :id="`dv_share_link_${i}`"
                                            :data-qe-id="`files-and-media_item_${i}_file-url`"
                                            class="share-link"
                                        >
                                            {{ getFileLink(element) }}
                                        </div>
                                    </v-flex>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                    </draggable>
                    <v-layout>
                        <v-flex
                            xs12
                            text-xs-center
                            pa-5
                            data-qe-id="files-and-media_no_media_message"
                            v-show="filesAndMediaData && filesAndMediaData.length === 0"
                        >
                            <span>{{ communityCommonConstant.filesAndMedia.NO_MEDIA }}</span>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <a :href="downloadFileUrl" download hidden ref="download"></a>
            </v-flex>
        </v-card-text>
        <v-card-actions>
            <v-flex xs12 text-right pa-2>
                <v-btn
                    class="primary_btn"
                    v-if="canViewShowMore"
                    :loading="filesLoadingAction.pending"
                    @click="showMore()"
                    >Show More</v-btn
                >
            </v-flex>
        </v-card-actions>
        <v-dialog v-model="isvalidateActionDialog" lazy absolute content-class="post-actions" persistent>
            <v-card>
                <v-flex tag="h6">
                    {{ confirmationTitle }}
                    <v-btn icon class="delete-dialog__close-btn" @click="cancelDialog()" data-qe-id="close_dialog_btn">
                        <v-icon size="20">close</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex tag="p">
                    {{ validationDialogMessage }}
                </v-flex>
                <v-flex text-xs-right>
                    <v-btn flat @click="cancelDialog()" data-qe-id="cancel_dialog_btn" class="primary_btn transparent">
                        {{ appCommonConstants.CANCEL }}
                    </v-btn>
                    <v-btn dark @click="confirmToSave()" data-qe-id="save_dialog_btn" class="primary_btn">
                        {{ appCommonConstants.CONFIRM }}
                    </v-btn>
                </v-flex>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { storeAction } from '@/store/storeActions.constant';
import { appCommonConstants, routerNames } from '../../appCommon.constants';
import {
    communityCommonConstant,
    iconClassNames,
    calculateFileSize,
} from '../communityCommon.constant';
import { storeGetters } from '../../../store/storeGetters.constant';
import FileUpload from 'vue-upload-component';
import { getShortDate } from '@/common/utils/dateTime';
import { orderBy } from 'lodash';
import FileDragDropArea from '../../FileDragDropArea/DragDropArea';
import draggable from 'vuedraggable';
import StatusOverlay from '../../StatusOverlay/StatusOverlay.vue';
import { imageErrorFallback } from '../../../common/utils/utils';
import { myToolsConstants } from '../../Tools/mytools.constant';

export default {
    name: 'FilesMediaList',
    components: {
        FileUpload,
        FileDragDropArea,
        StatusOverlay,
        draggable,
    },
    props: ['filesAndMediaDataRefreshFlag', 'navigateToFolderOnOpen'],
    created() {
        this.validationDialogMessage = this.communityCommonConstant.filesAndMedia.DATA_SAVE_CONF_MESSAGE;
    },
    watch: {
        filesAndMediaList(newCount) {
            this.filesAndMediaData = newCount;
            this.updateFileElementQuery();
            if (!this.canReorder) {
                this.orderMediaBy(this.sortKey, false);
            }
        },
        //! what is data referesh
        filesAndMediaDataRefreshFlag() {
            this.resetDefaultValues();
            this.updateFileElementQuery();
            //this.getCommunityName();
            if (!this.canReorder) {
                this.orderMediaBy(this.sortKey, this.asc);
            }
            if (this.navigateToFolderOnOpen) {
                this.navigateToFolder(this.navigateToFolderOnOpen);
            }
        },
    },
    data: () => ({
        confirmationTitle: '',
        communityCommonConstant,
        appCommonConstants,
        routerNames,
        currentRootOriginalOrder: [],
        validationDialogMessage: '',
        isReordered: false,
        downloadFileUrl: '',
        shareLinkCopiedMessage: '',
        deleteInProgress: false,
        saveInProgress: false,
        updateInProgress: false,
        filesAndMediaError: false,
        isEditError: false,
        isSaveError: false,
        isErrorMessage: '',
        nameAsc: true,
        typeAsc: true,
        dateAsc: true,
        modifiedByAsc: true,
        sortKey: 'lastModifiedDate',
        isAddFolder: true,
        isCloseDialog: false,
        isDeleteRow: false,
        //communityName: "",
        isError: false,
        sortSettingsArray: [],
        asc: false,
        isEditName: '',
        editNameExtesion: '',
        canNavigateUp: false,
        parentName: '',
        currentRoot: null,
        filesAndMediaData: [],
        isShowFilesContainer: false,
        isvalidateActionDialog: false,
        isExistItemName: '',
        pageNumber: 1,
        pageSize: 10,
    }),
    methods: {
        imageErrorFallback,
        resetDefaultValues() {
            this.filesAndMediaList.forEach((element) => {
                element.isEditRow = false;
                element.isNewRow = false;
                element.isDeleteRow = false;
                element.downloadInProgress = false;
            });
            this.currentRootOriginalOrder = [];
            this.validationDialogMessage = '';
            this.isReordered = false;
            this.downloadFileUrl = '';
            this.shareLinkCopiedMessage = '';
            this.deleteInProgress = false;
            this.saveInProgress = false;
            this.updateInProgress = false;
            this.filesAndMediaError = false;
            this.isEditError = false;
            this.isSaveError = false;
            this.isErrorMessage = '';
            this.nameAsc = true;
            this.typeAsc = true;
            this.dateAsc = true;
            this.modifiedByAsc = true;
            this.isAddFolder = true;
            this.isCloseDialog = false;
            this.isDeleteRow = false;
            this.isError = false;
            this.sortSettingsArray = [];
            this.asc = false;
            this.isEditName = '';
            this.editNameExtesion = '';
            this.canNavigateUp = false;
            this.parentName = '';
            this.currentRoot = null;
            this.filesAndMediaData = [];
            this.isShowFilesContainer = false;
            this.isvalidateActionDialog = false;
        },
        home() {
            const retval = this.validateActions(communityCommonConstant.filesAndMedia.ACTIONS.EDIT);
            if (retval) {
                this.currentRoot = null;
                this.canNavigateUp = false;
                this.updateFileElementQuery();
            }
        },
        changeOrder() {
            if (this.isReordered) {
                this.filesAndMediaData.forEach((element, index) => {
                    element.order = index + 1;
                });
            }
        },
        onListItemMove() {
            this.isReordered = true;
        },
        cancelOrder() {
            this.filesAndMediaData.forEach((ele) => {
                ele.order = this.currentRootOriginalOrder.find(item => item.id === ele.id).order;
            });
            this.filesAndMediaData = orderBy(this.filesAndMediaData, 'order', 'asc');
            this.isReordered = false;
        },
        saveOrder() {
            this.isReordered = false;
            this.saveFilesandMediaReorderList(this.filesAndMediaData);
        },
        previewFile(fileUrl) {
            window.open(fileUrl, '_blank');
        },
        copyFileLink(linkContainerId) {
            const range = document.createRange();
            range.selectNode(document.getElementById(linkContainerId));
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);
            setTimeout(() => {
                document.execCommand('copy');
            }, 0);
            this.shareLinkCopiedMessage = this.communityCommonConstant.filesAndMedia.LINK_COPIED_MESSAGE;
            setTimeout(() => {
                this.shareLinkCopiedMessage = '';
            }, 2000);
        },
        getFileCount(id) {
            const itemsCount = this.filesAndMediaList.find(f => f.id === id).fileCount;
            return itemsCount === 1
                ? `1 ${this.communityCommonConstant.filesAndMedia.ITEM}`
                : `${itemsCount} ${this.communityCommonConstant.filesAndMedia.ITEMS}`;
        },
        getFileSize(sizeInBytes) {
            return this.calculateFileSize(sizeInBytes, this.communityCommonConstant.filesAndMedia);
        },
        calculateFileSize,
        //Creating Folders
        folderActivity() {
            const retval = this.validateActions(communityCommonConstant.filesAndMedia.ACTIONS.NEW);
            if (retval) {
                this.isAddFolder = false;
                const obj = JSON.parse(JSON.stringify(this.communityCommonConstant.filesAndMedia.newfolder));
                this.filesAndMediaData.splice(0, 0, obj);
                const refs = this.$refs;
                setTimeout(() => {
                    refs.newFolderField[0].select();
                }, 0);
            }
        },
        saveFolder(element) {
            if (element.name !== '') {
                if (
                    this.filesAndMediaData.filter(o => o.name.toLowerCase().trim() === element.name.toLowerCase().trim()).length === 1
                ) {
                    this.filesAndMediaError = false;
                    const fileObject = {};
                    fileObject.parentId = this.currentRoot === null ? null : this.currentRoot.id;
                    fileObject.DirectoryName = element.name;
                    fileObject.ParentDirectory = this.currentRoot === null ? null : this.currentRoot.fileUrl;
                    this.saveInProgress = true;
                    this.createDirectory(fileObject)
                        .then(() => {
                            this.isAddFolder = true;
                            this.saveInProgress = false;
                        })
                        .catch((error) => {
                            if (error && error.message === communityCommonConstant.filesAndMedia.DIRECTORY_ALREADY_EXISTS) {
                                this.filesAndMediaError = true;
                            }
                            this.saveInProgress = false;
                        });
                } else {
                    this.filesAndMediaError = true;
                }
            } else {
                return false;
            }
        },
        getFileLink(element) {
            return `${window.location.href.split('#')[0]}#/download/${element.id}`;
        },
        //end

        //Update Folder names
        editGridRow(itemofRow) {
            this.isExistItemName = itemofRow.name;
            const retval = this.validateActions(communityCommonConstant.filesAndMedia.ACTIONS.EDIT);
            if (retval) {
                const fileName = this.filesAndMediaData.find(item => item.id === itemofRow.id).name;
                if (fileName.lastIndexOf('.') > 0) {
                    this.isEditName = fileName.substring(0, fileName.lastIndexOf('.'));
                    this.editNameExtesion = fileName.substring(fileName.lastIndexOf('.'), fileName.length);
                } else {
                    this.isEditName = fileName;
                    this.editNameExtesion = '';
                }
                this.filesAndMediaData.find(item => item.id === itemofRow.id).isEditRow = true;
            }
        },
        async updateDetails(element) {
            if (this.isEditName !== '' && !this.filesAndMediaError) {
                element.isEditRow = true;
                element.isNewRow = false;
                element.isDeleteRow = false;
                const obj = {};
                obj.communityId = element.communityId;
                obj.name = this.isEditName + this.editNameExtesion;
                obj.id = element.id;
                obj.ParentDirectory = this.currentRoot === null ? null : this.currentRoot.fileUrl;

                this.updateInProgress = true;
                await this.updateDirectory(obj);
                this.updateInProgress = false;
            } else {
                return false;
            }
        },
        //end
        cancelDialog() {
            this.isvalidateActionDialog = false;
        },
        orderMediaBy(sorKey, asc) {
            const retval = this.validateActions(communityCommonConstant.filesAndMedia.ACTIONS.REORDER);
            if (retval) {
                const parentId = this.currentRoot ? this.currentRoot.parentId : null;
                this.sortKey = sorKey;
                if (this.currentRoot || !this.sortSettingsArray.some(o => o.parentId === parentId)) {
                    this.sortSettingsArray.push({ parentId, sortKey: this.sortKey, asc: this.asc });
                }
                if (this.sortSettingsArray.some(o => o.parentId === parentId)) {
                    this.sortSettingsArray.find(o => o.parentId === parentId).sortKey = this.sortKey;
                    this.sortSettingsArray.find(o => o.parentId === parentId).asc = asc;
                }
                this.filesAndMediaData = orderBy(this.filesAndMediaData, this.sortKey, asc ? 'asc' : 'desc');

                if (this.sortKey === communityCommonConstant.filesAndMedia.tableColumns.TYPE.value) {
                    this.typeAsc = !asc;
                }
                if (this.sortKey === communityCommonConstant.filesAndMedia.tableColumns.NAME.value) {
                    this.nameAsc = !asc;
                }
                if (this.sortKey === communityCommonConstant.filesAndMedia.tableColumns.LAST_MODIFIED.value) {
                    this.dateAsc = !asc;
                }
                if (this.sortKey === communityCommonConstant.filesAndMedia.tableColumns.MODIFIED_BY.value) {
                    this.modifiedByAsc = !asc;
                }

                this.asc = !asc;
            }
        },
        getShortDate,
        closeFilesDialog() {
            this.isCloseDialog = true;
            if (this.validateActions(communityCommonConstant.filesAndMedia.ACTIONS.CLOSE)) {
                this.isShowFilesContainer = false;
                this.$emit('close');
            }
        },
        closeFilesDragDropArea() {
            this.isShowFilesContainer = false;
        },
        deleteItem(element) {
            const retval = this.validateActions(communityCommonConstant.filesAndMedia.ACTIONS.DELETE);
            if (retval) {
                element.isEditRow = false;
                element.isDeleteRow = true;
                element.isNewRow = false;
                this.isDeleteRow = true;
                this.isCloseDialog = false;
                this.isvalidateActionDialog = false;
            }
        },
        navigateToFolder(element) {
            this.pageNumber = 1;
            const selectedFOlderCount = this.filesAndMediaList.filter(o => o.parentId === element.id).length;
            if (selectedFOlderCount < this.pageSize) {
                this.getFilesAndMedia({ parentId: element.id, pageNumber: this.pageNumber, pageSize: this.pageSize });
            }
            const retval = this.validateActions(communityCommonConstant.filesAndMedia.ACTIONS.FOLDER);
            if (retval) {
                this.currentRoot = element;
                this.updateFileElementQuery();
                this.canNavigateUp = true;
                if (!this.sortSettingsArray.some(o => o.parentId === element.parentId)) {
                    this.sortSettingsArray.push({ parentId: element.parentId, sortKey: this.sortKey, asc: this.asc });
                }
                this.getCurrentRootParent();
            }
        },
        getCurrentRootParent() {
            if (this.currentRoot && !this.currentRoot.isRoot && this.currentRoot.parentId) {
                this.parentName = this.filesAndMediaList.find(item => item.id === this.currentRoot.parentId).name;
            }
        },
        navigateUp() {
            const retval = this.validateActions(communityCommonConstant.filesAndMedia.ACTIONS.REORDER);
            if (retval) {
                if (this.currentRoot && this.currentRoot.isRoot) {
                    this.currentRoot = null;
                    this.canNavigateUp = false;
                } else {
                    this.currentRoot = this.filesAndMediaList.find(o => o.id === this.currentRoot.parentId);
                }
                this.updateFileElementQuery();
                if (this.sortSettingsArray.some(o => o.parentId === this.currentRoot.parentId)) {
                    this.sort = this.sortSettingsArray.find(o => o.parentId === this.currentRoot.parentId);
                }
                this.getCurrentRootParent();
                this.filesAndMediaData = orderBy(
                    this.filesAndMediaData,
                    this.sort.sortKey,
                    this.sort.asc ? 'asc' : 'desc',
                );
                if (this.sortKey === communityCommonConstant.filesAndMedia.tableColumns.TYPE.value) {
                    this.typeAsc = this.sort.asc;
                } else if (this.sortKey === communityCommonConstant.filesAndMedia.tableColumns.NAME.value) {
                    this.nameAsc = this.sort.asc;
                } else if (this.sortKey === communityCommonConstant.filesAndMedia.tableColumns.LAST_MODIFIED.value) {
                    this.dateAsc = this.sort.asc;
                } else if (this.sortKey === communityCommonConstant.filesAndMedia.tableColumns.MODIFIED_BY.value) {
                    this.modifiedByAsc = this.sort.asc;
                }
            }
        },
        showMore() {
            const parentId = this.currentRoot ? this.currentRoot.id : null;
            const count = this.filesAndMediaList.filter(o => o.parentId === parentId).length;
            const pageNumber = Math.round(count / this.pageSize);
            this.getFilesAndMedia({
                parentId,
                pageNumber: pageNumber + 1,
                pageSize: this.pageSize,
            });
        },
        updateFileElementQuery() {
            const qeryById = this.currentRoot ? this.currentRoot.id : null;
            this.filesAndMediaData = this.filesAndMediaList.filter(element => element.parentId === qeryById);
            if (this.canReorder) {
                this.filesAndMediaData = orderBy(this.filesAndMediaData, 'order', 'asc');
                this.currentRootOriginalOrder = this.filesAndMediaData.map(a => Object.assign({}, a));
            }
        },
        ...mapActions({
            createDirectory: `chapter/${storeAction.createDirectory}`,
            saveFilesandMediaReorderList: `chapter/${storeAction.saveFilesandMediaReorderList}`,
            updateDirectory: `chapter/${storeAction.updateDirectory}`,
            getFilesAndMedia: `chapter/${storeAction.getFilesAndMedia}`,
            deleteFilesAndMedia: `chapter/${storeAction.deleteFilesAndMedia}`,
            getDownloadFolders: `chapter/${storeAction.getDownloadFolders}`,
        }),
        displayFilesLayout() {
            this.isShowFilesContainer = true;
        },
        iconClassNames,

        confirmToSave() {
            this.isvalidateActionDialog = false;
            if (this.isReordered) {
                this.saveOrder();
                if (this.isCloseDialog) {
                    this.isShowFilesContainer = false;
                    this.$emit('close');
                }
            } else {
                const isEditRow = this.filesAndMediaData.find(o => o.isEditRow === true);
                const isNewRow = this.filesAndMediaData.find(o => o.isNewRow === true);
                const isDeleteRow = this.filesAndMediaData.find(o => o.isDeleteRow === true);
                if (isEditRow) {
                    this.updateDetails(isEditRow);
                } else if (isNewRow) {
                    this.saveFolder(isNewRow);
                } else if (this.isDeleteRow) {
                    this.deleteDetails(isDeleteRow);
                }
                if (this.isCloseDialog) {
                    this.isShowFilesContainer = false;
                    this.$emit('close');
                }
            }
        },
        cancelEmptyRow(ind) {
            this.filesAndMediaError = false;
            this.isAddFolder = true;
            this.filesAndMediaError = false;
            this.filesAndMediaData.splice(ind, 1);
        },

        cancelDetails(itemofRow) {
            this.isAddFolder = true;
            this.filesAndMediaError = false;
            this.filesAndMediaData.find(item => item.id === itemofRow.id).isEditRow = false;
        },

        duplicateName(fieldName, type, isFolder) {
            if (fieldName) {
                this.filesAndMediaError = false;
                this.isEditError = false;
                this.isSaveError = false;
                this.isErrorMessage = '';
                if (fieldName.length > 0) {
                    let count;
                    if (isFolder) {
                        count = this.filesAndMediaData.filter(item => item.name.toLowerCase().trim() === fieldName.toLowerCase().trim()).length;
                    } else {
                        count = this.filesAndMediaData.filter(item =>
                                item.name
                                    .substring(0, item.name.lastIndexOf('.'))
                                    .toLowerCase()
                                    .trim() === fieldName.toLowerCase().trim()).length;
                    }
                    if (type === appCommonConstants.UPDATE && count > 0) {
                        if (
                            this.isExistItemName.toLowerCase().trim() !==
                            (fieldName + this.editNameExtesion).toLowerCase().trim()
                        ) {
                            this.filesAndMediaError = true;
                            return false;
                        }
                    } else if (type === appCommonConstants.SAVE && count > 1) {
                        this.filesAndMediaError = true;
                        return false;
                    }
                    this.filesAndMediaError = false;
                }
            }
        },
        async deleteDetails(element) {
            const obj = {};
            obj.DirectoryName = this.currentRoot ? this.currentRoot.name : null;
            obj.communityId = element.communityId;
            obj.id = element.id;
            obj.fileType = element.fieldType;
            obj.parentId = element.parentId;
            obj.fileSize = element.fileSize;
            obj.ParentDirectory = this.currentRoot === null ? null : this.currentRoot.fileUrl;

            this.deleteInProgress = true;
            await this.deleteFilesAndMedia(obj);
            this.deleteInProgress = false;
        },
        deleteCancel(element) {
            element.isDeleteRow = false;
            element.isEditRow = true;
        },
        isValidFolderName($event, FolderName) {
            if (
                $event.charCode === 0 ||
                ($event.charCode >= 48 && $event.charCode <= 57) ||
                ($event.charCode >= 65 && $event.charCode <= 90) ||
                ($event.charCode >= 97 && $event.charCode <= 122) ||
                $event.charCode === 95 ||
                $event.charCode === 32
            ) {
                return true;
            }
            if (FolderName.length >= 64) {
                $event.preventDefault();
                return true;
            }
            $event.preventDefault();
        },

        validateActions(typeofaction) {
            let isValid = true;
            this.isvalidateActionDialog = false;
            const isEdit = this.filesAndMediaData.find(e => e.isEditRow === true);
            const isNew = this.filesAndMediaData.find(n => n.isNewRow === true);
            const isDelete = this.filesAndMediaData.find(e => e.isDeleteRow === true);
            if (isDelete) {
                this.isDeleteRow = true;
            }
            if (
                this.isReordered ||
                isNew ||
                isDelete ||
                (isEdit && typeofaction !== this.communityCommonConstant.filesAndMedia.ACTIONS.DELETE) ||
                (isEdit && this.isEditName + this.editNameExtesion !== isEdit.name)
            ) {
                isValid = false;
                this.isvalidateActionDialog = true;
                if (isNew) {
                    this.confirmationTitle = communityCommonConstant.filesAndMedia.SAVE;
                } else if (isEdit) {
                    this.confirmationTitle = communityCommonConstant.filesAndMedia.UPDATE;
                } else if (isDelete) {
                    this.confirmationTitle = communityCommonConstant.filesAndMedia.DELETE;
                } else if (this.isReordered) {
                    this.confirmationTitle = communityCommonConstant.filesAndMedia.REORDER;
                }
                this.validationDialogMessage = this.communityCommonConstant.filesAndMedia.DATA_SAVE_CONF_MESSAGE;
            }
            return isValid;
        },

        downloadFolders(element) {
            element.downloadInProgress = true;
            this.getDownloadFolders(element).then(() => {
                element.downloadInProgress = false;
                return true;
            });
        },
        showDownloadIcon(element) {
            return !element.downloadInProgress && ((element.isFolder && element.fileCount > 0) || !element.isFolder);
        },
    },
    computed: {
        ...mapState('actionState', ['actions']),
        ...mapGetters('chapter', [
            storeGetters.filesAndMediaList,
            storeGetters.usersCommunitiesList,
            storeGetters.canReorder,
            storeGetters.communityInfo,
            storeGetters.rootFolderCount,
        ]),
        filesLoadingAction() {
            return this.actions[storeAction.getFilesAndMedia];
        },
        canViewEdit() {
            return (
                this.canReorder ||
                (this.communityInfo &&
                    this.communityInfo.communityId === this.$route.params.communityId &&
                    this.communityInfo.userAccess &&
                    this.communityInfo.userAccess.canEditMyOwnFilesAndMedia)
            );
        },
        communityName() {
            return this.communityInfo ? this.communityInfo.name : '';
        },
        isVisible() {
            if (this.isAllNetworks) {
                return this.canReorder;
            }
            return true;
        },
        isAllNetworks() {
            return (
                this.usersCommunitiesList &&
                this.usersCommunitiesList.some(o => o.communityId === this.$route.params.communityId && o.name.toLowerCase() === myToolsConstants.YOUR_NETWORKS_CONSOLIDATED_LOWER_CASE)
            );
        },
        isRowEditingOrCreating() {
            return (
                this.filesAndMediaData.filter((ele) => {
                    return ele.isEditRow || ele.isNewRow || ele.isDeleteRow;
                }).length > 0
            );
        },
        canViewShowMore() {
            if (this.currentRoot === null) {
                const count = this.filesAndMediaList.filter(o => o.parentId === null).length;
                return count < this.rootFolderCount;
            }
            if (this.currentRoot) {
                const count = this.filesAndMediaList.filter(o => o.parentId === this.currentRoot.id).length;
                return !this.currentRoot.fileCount < this.pageSize && count < this.currentRoot.fileCount;
            }
        },
    },
};
</script>

<style lang="scss">
@import '../../../common/styles/_colors.scss';
@import '../../../common/styles/_responsive.scss';

.files-media-popup {
    &__sub {
        display: block;
        width: 100%;
        font-family: 'Noto Sans', sans-serif;
        font-size: 13px;
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 16px;
        text-transform: uppercase;
        margin-top: 3px;
    }

    .v-list__tile {
        padding: 0;
    }

    &__icons {
        text-align: right;
        padding: 20px 0;

        .v-icon {
            color: $ypo-dark-background-gray !important;
            margin: 0 14px;
            font-size: 20px;
            @include breakpoint(xs) {
                margin: 0 12px;
            }
        }
    }

    &__breadcrumb {
        padding: 20px 20px;
        color: $ypo-cta;
        font-size: 16px;
        font-weight: bold;

        .fa-home {
            margin: 0 10px 0 0;
            font-size: 20px;
            cursor: pointer;
        }

        strong {
            margin-left: 10px;
            color: $ypo_blue;

            i {
                margin-right: 10px;
            }
        }
    }

    .headding {
        background: $ypo-tile-border;
        padding: 10px;
        color: $ypo-dark-gray;
        font-size: 14px;
        font-weight: bold;
        line-height: 24px;

        a {
            position: relative;
            color: $ypo-dark-gray;

            .fas {
                font-size: 20px;
                color: $ypo_cta;

                &.fa-sort-down {
                    position: relative;
                    left: 3px;
                    top: -2px;
                }

                &.fa-sort-up {
                    position: relative;
                    top: 7px;
                    left: 3px;
                }
            }
        }
    }

    .dragDiv {
        margin: 15px 10px;
        padding: 10px;
        align-items: center;
        box-shadow: 0 2px 4px 0 rgba($black, 0.5);

        &.cursor-move {
            cursor: move;
        }
    }

    .typeBlock {
        span {
            color: $ypo-dark-background-gray;
            font-size: 9px;
            font-weight: bold;
            letter-spacing: 0.59px;
            line-height: 12px;
            display: block;
            text-transform: uppercase;
        }

        i {
            color: $ypo-dark-background-gray;
            margin: 5px 0;
        }
    }

    .nameBlock {
        strong {
            color: $ypo_blue;
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0.19px;
            line-height: 26px;
            word-break: break-all;

            &.pointer {
                &:hover {
                    color: $ypo-cta;
                }
            }
        }
    }

    .actionsBlock {
        .v-icon {
            font-size: 16px;
            color: $ypo-cta !important;
            margin: 0 8px;
            cursor: pointer;

            &:hover {
                color: $ypo_blue !important;
            }
        }

        @include breakpoint(sm) {
            .v-icon {
                margin: 0 8px;
                font-size: 14px;
            }
        }
    }

    .inputBlock {
        background: $ypo-dark-background-gray;
        padding: 10px 10px;

        input {
            width: 100%;
            min-height: 40px;
            color: $white;
            border-bottom: 1px solid $white;
            top: 0;

            &:focus {
                outline: none;
            }
        }
    }

    .btns_div {
        .v-btn {
            margin: 15px 3px;
            padding: 5px 15px;
        }
    }

    .delete_box {
        background: $ypo_blue;
        flex: auto;
        margin: -10px;
        max-width: inherit;
        padding: 20px 30px 20px 10px;

        &__title {
            color: $white;
            padding: 10px 0 0 50px;
            align-items: center;
        }

        &__btns {
            .v-btn {
                border: 1px solid $white;
                font-weight: 500;
            }
        }
    }
}

.error-msg {
    color: $ypo-error-red;
    position: relative;
    left: 25px;
    top: 20px;
}

.last-modified-by {
    color: $ypo_blue;
}

.download-progress-circle {
    margin: 1rem;
    color: $ypo_blue;
}

.share-link {
    opacity: 0;
    font-size: 0;

    &-copied-message {
        font-size: 16px;
        text-align: center;
        padding: 3px 30px;
        color: $ypo-cta;
    }
}

@media (max-width: 767px) {
    .files-media-popup {
        &__header {
            padding: 5px 0 20px 30px;

            h3 {
                font-size: 24px;
            }
        }

        .last-modified-by {
            border-top: 1px dashed $ypo-medium-gray;
            border-bottom: 1px dashed $ypo-medium-gray;
            margin: 10px 0;
            padding: 5px 0;
        }

        .nameBlock strong {
            font-size: 12px;
            line-height: normal;
        }
    }
}
</style>
